import type { ProLayoutProps } from '@ant-design/pro-components';
import { site } from '../src/config/site';

const Settings: ProLayoutProps & {
    pwa?: boolean;
    logo?: string;
} = {
    navTheme: 'light',
    colorPrimary: '#0f766e',
    layout: 'mix',
    contentWidth: 'Fluid',
    fixedHeader: false,
    fixSiderbar: true,
    colorWeak: false,
    /** 标题由 headerTitleRender 自定义（logo 底对齐） */
    title: '管理后台',
    pwa: true,
    logo: '/main-logo.png',
    iconfontUrl: '',
    token: {},
};

export default Settings;

/** 浏览器标签等场景仍用完整后台名 */
export const documentTitle = site.adminTitle;
